var map = {
	"./legend.png": 92063,
	"./legend_dark.png": 8904,
	"./legend_english.png": 82550,
	"./legend_english_dark.png": 17783,
	"./legend_spanish.png": 5894,
	"./legend_spanish_dark.png": 7463,
	"./legend_xa.png": 5137,
	"./legend_xa_dark.png": 23610,
	"./legend_xa_dark_vertical.png": 81561,
	"./legend_xa_english.png": 4707,
	"./legend_xa_english_dark.png": 24729,
	"./legend_xa_english_dark_vertical.png": 78996,
	"./legend_xa_english_vertical.png": 26979,
	"./legend_xa_spanish.png": 53680,
	"./legend_xa_spanish_dark.png": 3865,
	"./legend_xa_spanish_dark_vertical.png": 95892,
	"./legend_xa_spanish_vertical.png": 94819,
	"./legend_xa_vertical.png": 28844,
	"./legend_xg.png": 74535,
	"./legend_xg_dark.png": 54208,
	"./legend_xg_dark_vertical.png": 84723,
	"./legend_xg_english.png": 90862,
	"./legend_xg_english_dark.png": 58015,
	"./legend_xg_english_dark_vertical.png": 36038,
	"./legend_xg_english_vertical.png": 61549,
	"./legend_xg_spanish.png": 9550,
	"./legend_xg_spanish_dark.png": 74495,
	"./legend_xg_spanish_dark_vertical.png": 14054,
	"./legend_xg_spanish_vertical.png": 39949,
	"./legend_xg_vertical.png": 64750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37658;